import React, { ComponentProps } from 'react';

import Tooltip, { TooltipProps } from 'components/mui/Tooltip';
import { styled } from '@mui/material/styles';

const TooltipButtonWrapper = styled('div')(() => ({
  display: 'inline-flex',
}));

type TWrapperProps = ComponentProps<typeof TooltipButtonWrapper>;

interface TooltipForButtonProps extends TooltipProps {
  WrapperProps?: TWrapperProps;
}

// MUI: You are providing a disabled `button` child to the Tooltip component.
//      A disabled element does not fire events.
//      Tooltip needs to listen to the child element's events to display the title.
// ================================================================================================
//      so its wrapper only for elements that can be disabled
// ================================================================================================
const TooltipForButton = ({ children, WrapperProps = {}, ...rest }: TooltipForButtonProps): JSX.Element => {
  return (
    <Tooltip {...rest}>
      <TooltipButtonWrapper {...WrapperProps}>{children}</TooltipButtonWrapper>
    </Tooltip>
  );
};

export default TooltipForButton;
